import { render, staticRenderFns } from "./OrderDetailPending.vue?vue&type=template&id=0b846a9c&scoped=true&"
import script from "./OrderDetailPending.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPending.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPending.vue?vue&type=style&index=0&id=0b846a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b846a9c",
  null
  
)

export default component.exports